export interface MockDataFormat{
    ReturnMessage: string;
    YearMonth: string;
    AgencyName: string;
    InvoiceNumber: string;
    InvoiceDate: string;
    InvoiceIssueDate: string;
    InvoiceDueDate: string;
    PreviousBalance: number;
    TotalDebits: number;
    TotalCredits: number;
    TotalPayments: number;
    TotalBalance: number;
    CurrentCharges: number;
    TotalAmountDue: number;
    invoiceUrl: string;
}

export const invoiceData = {
    isLoading: false,
    loadingError: null,
    sorting: 'ASC',
    invoices: [
        {  id: 1,
            url: 'xyz',
            name: 'mohit',
            creationDate: '02061999',
            fileDate: new Date('2022-01-20')
        }
            ,
        {id: 1,
            url: 'xyz',
            name: 'mohit',
            creationDate: '02061999',
            fileDate: new Date('2022-02-20')},
        {id: 1,
            url: 'xyz',
            name: 'mohit',
            creationDate: '02061999',
            fileDate: new Date('2022-03-20')}
            ,
        {id: 1,
            url: 'xyz',
            name: 'mohit',
            creationDate: '02061999',
            fileDate: new Date('2022-04-20') }

    ]
};
const agencyName= 'Inter-Bridge Tvl & Consulting Svc';
export const mockData: MockDataFormat[]=
  [
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202301',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093109966',
        'InvoiceDate': '2023-01-02 00:00:00',
        'InvoiceIssueDate': '2021-07-02 00:00:00',
        'InvoiceDueDate': '',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 200106744.80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test.pdf'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202212',
        'AgencyName': agencyName,
        'InvoiceNumber': '',
        'InvoiceDate': '2022-12-03 00:00:00',
        'InvoiceIssueDate': '2021-07-03 00:00:00',
        'InvoiceDueDate': '2021-07-03 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 45.989,
        'TotalAmountDue': 187.94,
        'invoiceUrl': ''
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202211',
        'AgencyName': agencyName,
        'InvoiceNumber': '',
        'InvoiceDate': '2022-11-04 00:00:00',
        'InvoiceIssueDate': '2021-07-04 00:00:00',
        'InvoiceDueDate': '2021-07-14 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 100,
        'TotalAmountDue': 187.94,
        'invoiceUrl': ''
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202210',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093109999',
        'InvoiceDate': '2022-10-05 00:00:00',
        'InvoiceIssueDate': '2021-07-05 00:00:00',
        'InvoiceDueDate': '2021-07-15 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 0,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202209',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093100068',
        'InvoiceDate': '2022-09-06 00:00:00',
        'InvoiceIssueDate': '2021-07-06 00:00:00',
        'InvoiceDueDate': '2021-07-16 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202208',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093101000',
        'InvoiceDate': '2022-08-07 00:00:00',
        'InvoiceIssueDate': '2021-07-07 00:00:00',
        'InvoiceDueDate': '2021-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 44.80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202206',
        'AgencyName': agencyName,
        'InvoiceNumber': '',
        'InvoiceDate': '2022-07-08 00:00:00',
        'InvoiceIssueDate': '2021-07-08 00:00:00',
        'InvoiceDueDate': '2021-07-18 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 71,
        'TotalAmountDue': 187.94,
        'invoiceUrl': ''
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202205',
        'AgencyName': agencyName,
        'InvoiceNumber': '',
        'InvoiceDate': '2022-06-09 00:00:00',
        'InvoiceIssueDate': '2021-07-09 00:00:00',
        'InvoiceDueDate': '2021-07-19 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 86,
        'TotalAmountDue': 187.94,
        'invoiceUrl': ''
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202204',
        'AgencyName': agencyName,
        'InvoiceNumber': '0076856754',
        'InvoiceDate': '2022-05-10 00:00:00',
        'InvoiceIssueDate': '2021-07-10 00:00:00',
        'InvoiceDueDate': '2021-07-10 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 55,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202203',
        'AgencyName': agencyName,
        'InvoiceNumber': '0065768967',
        'InvoiceDate': '2022-04-11 00:00:00',
        'InvoiceIssueDate': '2021-07-12 00:00:00',
        'InvoiceDueDate': '2021-07-18 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 67,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202202',
        'AgencyName': agencyName,
        'InvoiceNumber': '0078674598',
        'InvoiceDate': '2027-03-24 00:00:00',
        'InvoiceIssueDate': '2027-07-01 00:00:00',
        'InvoiceDueDate': '2027-07-12 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 43,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202201',
        'AgencyName': agencyName,
        'InvoiceNumber': '0709734567',
        'InvoiceDate': '2026-02-01 00:00:00',
        'InvoiceIssueDate': '2026-07-02 00:00:00',
        'InvoiceDueDate': '2026-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 26,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202112',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093987867',
        'InvoiceDate': '2025-01-12 00:00:00',
        'InvoiceIssueDate': '2025-07-02 00:00:00',
        'InvoiceDueDate': '2025-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 58,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202111',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093103429',
        'InvoiceDate': '2023-12-01 00:00:00',
        'InvoiceIssueDate': '2030-07-02 00:00:00',
        'InvoiceDueDate': '2028-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 51,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202110',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093106786',
        'InvoiceDate': '2023-10-01 00:00:00',
        'InvoiceIssueDate': '2031-07-02 00:00:00',
        'InvoiceDueDate': '2023-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 44.80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202109',
        'AgencyName': agencyName,
        'InvoiceNumber': '4564568345',
        'InvoiceDate': '2023-09-01 00:00:00',
        'InvoiceIssueDate': '2031-07-02 00:00:00',
        'InvoiceDueDate': '2045-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 44.80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202108',
        'AgencyName': agencyName,
        'InvoiceNumber': '0234523679',
        'InvoiceDate': '2023-08-01 00:00:00',
        'InvoiceIssueDate': '2023-07-02 00:00:00',
        'InvoiceDueDate': '2041-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 44.80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    },
    {
        'ReturnMessage': 'OK',
        'YearMonth': '202107',
        'AgencyName': agencyName,
        'InvoiceNumber': '0093101678',
        'InvoiceDate': '2022-07-01 00:00:00',
        'InvoiceIssueDate': '2022-07-02 00:00:00',
        'InvoiceDueDate': '2022-07-17 00:00:00',
        'PreviousBalance': 143.14,
        'TotalDebits': 0.00,
        'TotalCredits': 0.00,
        'TotalPayments': 0.00,
        'TotalBalance': 143.14,
        'CurrentCharges': 44.80,
        'TotalAmountDue': 187.94,
        'invoiceUrl': 'test'
    }
];

